import { SelectionModel } from '@angular/cdk/collections';
import { NestedTreeControl } from '@angular/cdk/tree';
import { Component, Input, OnInit } from '@angular/core';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { BehaviorSubject } from 'rxjs';
import { StudentService } from '../../children/service/student.service';
import { CoeRelatedStudent } from './coe-related-student';

@Component({
    selector: 'app-multi-select-coe-student',
    templateUrl: './multi-select-coe-student.component.html',
    styleUrls: ['./multi-select-coe-student.component.scss']
})
export class MultiSelectCoeStudentComponent implements OnInit {
    @Input() partyId: number = 0;
    CoeRelatedStudents: CoeRelatedStudent[] = [];

    constructor(private studentService: StudentService) {
        this.initialize();
    }

    initialize() {}

    ngOnInit(): void {
        if (this.partyId > 0) {
            console.log(this.partyId);
            this.getCoeRelatedStudents(this.partyId);
        }
    }

    getCoeRelatedStudents(partyId: number) {
        let coeRelatedStudentPayload: any = { party: { ID: partyId } };
        this.studentService.getCoeRelatedStudents(coeRelatedStudentPayload).subscribe((x) => {
            this.CoeRelatedStudents = x['coes'];
        });
    }
}
